import {getStore} from '../store';
import * as uiActions from '../actions/uiActions'

export function addMessage(payload) {
  getStore().dispatch(uiActions.addMessage(payload))
}

export function removeMessage(payload) {
  getStore().dispatch(uiActions.removeMessage(payload))
}

export function tooltip(type, message, timeout = 800) {
  const node = tooltipMessage(type, message)
  if (node) {
    node.classList.add("is-open")
    window.setTimeout(() => removeTooltip(node), timeout)
  }
}

function tooltipMessage(type, message) {
  let tooltipElement = document.createElement("div")
  tooltipElement.className = "tooltip-message"
  tooltipElement.textContent = message
  tooltipElement.classList.add(`is-${type}`)
  const node = document.body.appendChild(tooltipElement)
  return node
}

function removeTooltip(node) {
  node.classList.remove("is-open")
  node.remove()
}